// import { TokenData, TokenDataBase } from "../../../../models/chocolate/TokenDataModel";
// import { Contract, ContractBase } from "../../../../models/chocolate/ContractDataModel";
// import { ListOwnedNFTElement } from "./fetchNfts";
// import { TokenDataType } from "../../../../controllers/tokenDataClientInterfaces";
import { ethers } from "ethers";
import { AssetContractTypeEnum, ContractBase, ItemMap, ListOwnedNFTElement, NetworkEnum, TokenDataBase, TokenDataType } from "./commonInterfacesAndEnums";
// import { AssetContractTypeEnum, NetworkEnum } from "../../../../lib/nft/config";
// import { ObjectId } from "bson";
// import { ItemMap } from "../../watchToEarn/commonInterfaces";
const axios = require('axios');


export const MoralisChainNames: ItemMap<string> = {
    mainnet: "eth",
    // mumbai: "mumbai",
    matic: "polygon",
    bscMainnet: "bsc"
};
// To parse this data:
//
//   import { Convert, MintData } from "./file";
//
//   const mintData = Convert.toMintData(json);

export interface MintData {
    total:     number;
    page:      number;
    page_size: number;
    cursor:    string;
    result:    Result[];
    status:    string;
}

export interface Result {
    token_address:       string;
    token_id:            string;
    amount:              string;
    owner_of:            string;
    token_hash:          string;
    block_number_minted: string;
    block_number:        string;
    contract_type:       string;
    name:                string;
    symbol:              string;
    token_uri:           string;
    metadata:            string;
    last_token_uri_sync: Date;
    last_metadata_sync:  Date;
    minter_address:      null;
    normalized_metadata: NormalizedMetadata;
}

export interface NormalizedMetadata {
    name:          string;
    description:   null;
    animation_url: null;
    external_link: null;
    image:         string;
    attributes:    any[];
}

// Converts JSON strings to/from your types
export class Convert {
    public static toMintData(json: string): MintData {
        return JSON.parse(json);
    }

    public static mintDataToJson(value: MintData): string {
        return JSON.stringify(value);
    }
}

export const getNFTsFromMoralis = async (companyId: string, address: string, walletId: string, contracts: ContractBase[] = [], chains: NetworkEnum[] = [], withMetadata: boolean = false ) => 
{
    
    const contractsResp: ContractBase[] = [];
    const tokens: ListOwnedNFTElement[] = [];


    const addressToContractMap: any = {};
    contracts.forEach((contract: ContractBase) => {
        addressToContractMap[contract.contractAddress] = contract;
    });


    const chainContractAddressMap: any = {};
    const contractOutMap: any = {};
    contracts.forEach((contract: ContractBase) => {
        
        if (!(chainContractAddressMap[contract.chain] )) {
            chainContractAddressMap[contract.chain] = [contract.contractAddress]
        }
        else {
            chainContractAddressMap[contract.chain].push(contract.contractAddress);
        }
    });


    // Convert array to set
    const chainSet = new Set(chains);
    const chainArray = Array.from(chainSet);

    // console.log("chainArray", chainArray);


    for (const chain of chainArray) {

        // console.log("chain", chain);

        if (!(MoralisChainNames[chain])) continue;

        // console.log("chain", chain);

        const contractAddresses = chainContractAddressMap[chain];
        
        const params = new URLSearchParams();

        params.append('chain', MoralisChainNames[chain]);
        params.append('format', 'decimal');
        params.append('limit', '100');
        (contractAddresses) && contractAddresses.forEach((contractAddress: string) => {
            params.append('token_addresses', contractAddress);
        });
        params.append('normalizeMetadata', 'true');

        // console.log(`https://deep-index.moralis.io/api/v2/${address}/nft`);

        const response = await axios.get(`https://deep-index.moralis.io/api/v2/${address}/nft`, {
            params: params,
            headers: {
                'X-API-Key': '4fQWEHS3tYWFPKRh8wInkmroLBPnJFf1nHKiuM69alsirhBzKx2WnpLH7F4r2aDs',
                'accept': 'application/json'
            }
        });

        const data: MintData = response.data;
        // console.log(data);

        data.result.forEach((token: Result) => {
            
            const contract = addressToContractMap[token.token_address] || contractOutMap[token.token_address];
            let fakeContractId;
            if (!contract) {
                fakeContractId = Date.now().toString(36) + Math.random().toString(36).substring(2);
            }

            const tokenData: TokenDataBase = {

                type: token.contract_type as TokenDataType,
                creatorId: companyId,
                name: token.normalized_metadata.name,
                description: token.normalized_metadata.description || "",
                externalUri: token.normalized_metadata.external_link || "",
                imageUri: token.normalized_metadata.image,
                videoUri: token.normalized_metadata.animation_url || "",
                supply: 1,
                decimals: 1, // @todo Are you sure????????
                attributes: token.normalized_metadata.attributes,
                externalMetadataUri: token.token_uri,
                assetContractId: contract ? contract.id : fakeContractId,          // Fill this before creating the tokenData
                tokenId: token.token_id,        // Generate a token id as soon as this data is recieved
                lazyForm: null,
                encodedFormBytes: null,

            } as TokenDataBase;

            const contractOut: ContractBase = {
                _id: contract ? contract.id : fakeContractId,
                id: contract ? contract.id : fakeContractId,
                chain: chain as NetworkEnum,
                description: "",
                name: "",
                symbol: token.symbol,
                type: token.contract_type as AssetContractTypeEnum,
                confirmed: true,
                contractAddress: ethers.utils.getAddress(token.token_address),
                creatorId: companyId,
                isExternal: true,
                isGlobal: false,
              } as ContractBase;

              contractsResp.push( contractOut );
              contractOutMap[token.token_address] = contractOut;

            const resp: any = {
                token: tokenData,
                quantity: ethers.BigNumber.from( token.amount ).toString(),
                exchange: [],
            }
            
            tokens.push(resp);
            
        });

    }

    return { tokens, contracts: contractsResp };
}

// {
//     "total": 40,
//     "page": 1,
//     "page_size": 2,
//     "cursor": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjdXN0b21QYXJhbXMiOnsid2FsbGV0QWRkcmVzcyI6IjB4ZjFiNmZjZWFjNjc4NGEyNjM2MDA1Njk3M2M0MWUwMDE3ZGVlMTJlNCJ9LCJrZXlzIjpbIjE2Njg2MTMxNjIuODM5Il0sIndoZXJlIjp7Im93bmVyX29mIjoiMHhmMWI2ZmNlYWM2Nzg0YTI2MzYwMDU2OTczYzQxZTAwMTdkZWUxMmU0In0sImxpbWl0IjoyLCJvZmZzZXQiOjAsIm9yZGVyIjpbXSwidG90YWwiOjQwLCJwYWdlIjoxLCJ0YWlsT2Zmc2V0IjoxLCJpYXQiOjE2Njg3OTE1Njh9.XiCsDTcYbgtIXghO8uEXDFJsGvdXaC-o5aaUJDgkQTg",
//     "result": [
//       {
//         "token_address": "0x593cb81d024609b6293fe9bc6d93b205fbc953cf",
//         "token_id": "5263",
//         "amount": "1",
//         "owner_of": "0xf1b6fceac6784a26360056973c41e0017dee12e4",
//         "token_hash": "64c56d7dda963f65fe1dfb122600525f",
//         "block_number_minted": "23108617",
//         "block_number": "23108672",
//         "contract_type": "ERC721",
//         "name": "Gunstar Metaverse Pet",
//         "symbol": "GSP",
//         "token_uri": "https://api.gunstar.io/v1/pets/5263.json",
//         "metadata": "{\"id\":5263,\"name\":\"woruffing#5263\",\"image\":\"https://data.gunstar.io/images/pets/1002.png\",\"image_pet_only\":\"https://data.gunstar.io/images/pets/1002_only.png\",\"image_thumb\":\"https://data.gunstar.io/images/pets/1002_thumb.png\",\"type\":1002,\"rarity\":\"normal\",\"variants\":{\"generation\":0,\"health\":2209,\"hpTier\":2,\"defense\":13,\"defTier\":4,\"movement\":12.32,\"movTier\":3,\"level\":1,\"skills\":{\"skill_1\":{\"skillId\":10006,\"delay\":137,\"minDmg\":113,\"maxDmg\":143,\"imageName\":\"https://data.gunstar.io/images/icons/skills/Woruffing_S1.png\",\"description\":\"Fires 1 worm shot. No other effects.\",\"tierMinDmg\":110,\"tierMaxDmg\":152,\"numberOfBullets\":1},\"skill_2\":{\"skillId\":10007,\"delay\":497,\"minDmg\":127,\"maxDmg\":147,\"imageName\":\"https://data.gunstar.io/images/icons/skills/Woruffing_S2.png\",\"description\":\"Fires 3 worm shots. No other effects.\",\"tierMinDmg\":120,\"tierMaxDmg\":168,\"numberOfBullets\":3},\"skill_3\":{\"skillId\":10008,\"delay\":940,\"minDmg\":167,\"maxDmg\":207,\"imageName\":\"https://data.gunstar.io/images/icons/skills/Woruffing_S3.png\",\"description\":\"Fires 1 mother worm shot. Splits into 5 smaller worm shot to deal massive damage.\",\"tierMinDmg\":160,\"tierMaxDmg\":228,\"numberOfBullets\":1}},\"passive\":{\"description\":\"100% chance to explodes upon death, dealing 10% damage of Woruffing's total HP to all nearby pets.\"}}}",
//         "last_token_uri_sync": "2022-11-16T15:36:55.454Z",
//         "last_metadata_sync": "2022-11-16T15:37:08.156Z",
//         "minter_address": null,
//         "normalized_metadata": {
//           "name": "woruffing#5263",
//           "description": null,
//           "animation_url": null,
//           "external_link": null,
//           "image": "https://data.gunstar.io/images/pets/1002.png",
//           "attributes": []
//         }
//       },
//       {
//         "token_address": "0x593cb81d024609b6293fe9bc6d93b205fbc953cf",
//         "token_id": "5262",
//         "amount": "1",
//         "owner_of": "0xf1b6fceac6784a26360056973c41e0017dee12e4",
//         "token_hash": "833c342e1dad4be92ed7c76d4770455a",
//         "block_number_minted": "23108617",
//         "block_number": "23108667",
//         "contract_type": "ERC721",
//         "name": "Gunstar Metaverse Pet",
//         "symbol": "GSP",
//         "token_uri": "https://api.gunstar.io/v1/pets/5262.json",
//         "metadata": "{\"id\":5262,\"name\":\"woruffing#5262\",\"image\":\"https://data.gunstar.io/images/pets/1002.png\",\"image_pet_only\":\"https://data.gunstar.io/images/pets/1002_only.png\",\"image_thumb\":\"https://data.gunstar.io/images/pets/1002_thumb.png\",\"type\":1002,\"rarity\":\"normal\",\"variants\":{\"generation\":0,\"health\":2055,\"hpTier\":0,\"defense\":12.8,\"defTier\":2,\"movement\":12.18,\"movTier\":1,\"level\":1,\"skills\":{\"skill_1\":{\"skillId\":10006,\"delay\":143,\"minDmg\":122,\"maxDmg\":152,\"imageName\":\"https://data.gunstar.io/images/icons/skills/Woruffing_S1.png\",\"description\":\"Fires 1 worm shot. No other effects.\",\"tierMinDmg\":110,\"tierMaxDmg\":152,\"numberOfBullets\":1},\"skill_2\":{\"skillId\":10007,\"delay\":531,\"minDmg\":141,\"maxDmg\":161,\"imageName\":\"https://data.gunstar.io/images/icons/skills/Woruffing_S2.png\",\"description\":\"Fires 3 worm shots. No other effects.\",\"tierMinDmg\":120,\"tierMaxDmg\":168,\"numberOfBullets\":3},\"skill_3\":{\"skillId\":10008,\"delay\":985,\"minDmg\":188,\"maxDmg\":228,\"imageName\":\"https://data.gunstar.io/images/icons/skills/Woruffing_S3.png\",\"description\":\"Fires 1 mother worm shot. Splits into 5 smaller worm shot to deal massive damage.\",\"tierMinDmg\":160,\"tierMaxDmg\":228,\"numberOfBullets\":1}},\"passive\":{\"description\":\"100% chance to explodes upon death, dealing 10% damage of Woruffing's total HP to all nearby pets.\"}}}",
//         "last_token_uri_sync": "2022-11-16T15:36:52.422Z",
//         "last_metadata_sync": "2022-11-16T15:37:14.493Z",
//         "minter_address": null,
//         "normalized_metadata": {
//           "name": "woruffing#5262",
//           "description": null,
//           "animation_url": null,
//           "external_link": null,
//           "image": "https://data.gunstar.io/images/pets/1002.png",
//           "attributes": []
//         }
//       }
//     ],
//     "status": "SYNCED"
//   }

